import { useEffect, useRef, useState } from "react";
// custom hook
import useGetData from "../../hook/getData.tsx";
// hook and query
import { GetPlans } from "../../services/client/plans/getPlans.tsx";
import { sendOrder } from "../../services/agent/orders/sendOrder.tsx";
// toast
import { toast } from "react-toastify";
import { toastOptions } from "../../features/toast/toast.tsx";
// error and form
import { useForm } from "react-hook-form";
// axios
import axios from "axios";
// router
import { useMutation } from "@tanstack/react-query";


export const Order = () => {
    // form
    const { register, handleSubmit }: any = useForm<any>();
    // states
    const [value, setValue] = useState<any>()
    const [coord, setCoord] = useState([51.42, 35.72]);
    const [order_id, setOrderId] = useState<any>();
    const [address, setAdress] = useState<any>();
    const [latitude, setLatitude] = useState<number | any>()
    const [longitude, setLongitude] = useState<number | any>()
    const markerRef = useRef<HTMLDivElement | null>(null);
    const { data: plans, isLoading } = useGetData(['plans'], GetPlans)
    useEffect(() => {
        if (!isLoading) {
            setOrderId(localStorage.getItem('order_id'));
        }
    }, [isLoading])
    let sendData = useMutation({
        mutationFn: sendOrder,
        onSuccess: (data: any) => {
            toast.success('با موفقیت ارسال شد.', toastOptions);
            window.open(data.url, '_self');
        },
        onError: (error: any) => {
            const errors: any = error.response.data?.message;
            if (errors) {
                for (const [, messages] of Object.entries(errors)) {
                    (messages as string[]).forEach((message) => {
                        toast.error(message, toastOptions);
                    });
                }
            }
        },
    });
    let pending = sendData.isPending;
    const onSubmit = (data: any) => {
        // eslint-disable-next-line no-mixed-operators
        if (!value || value === null || value === '' && address === '' || address === null) {
            toast.error('تاریخ  و آدرس را به درستی وارد نمایید', toastOptions)
        }
        else {
            const dataToForm: any = new FormData();
            Object.entries(data).forEach(([key, value]: any) => {
                if (value !== undefined && value !== null) {
                    dataToForm.append(key, value);
                }
            });
            dataToForm.append('address', address);
            dataToForm.append('longitude', longitude);
            dataToForm.append('latitude', latitude);
            dataToForm.append('time', value);
            sendData.mutate(dataToForm)
        }
    };
    const reverseFunction = async (map, e) => {
        let configs = {
            headers: {
                "Content-Type": "application/json",
                "x-api-key": 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjllMmFiMjE4MjEzMjI4YmIyMTM5OWFlNjgyNTRkN2Y3NThmYWU3NGRmZGQ2NjViN2RhZGVmMWIxOWFhODg0YTMzMDVlZGUxOWUyOTVjYTEyIn0.eyJhdWQiOiIyNDM2NiIsImp0aSI6IjllMmFiMjE4MjEzMjI4YmIyMTM5OWFlNjgyNTRkN2Y3NThmYWU3NGRmZGQ2NjViN2RhZGVmMWIxOWFhODg0YTMzMDVlZGUxOWUyOTVjYTEyIiwiaWF0IjoxNjk2MzcyNTkyLCJuYmYiOjE2OTYzNzI1OTIsImV4cCI6MTY5ODg3ODE5Miwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.oEE6bnb9YLzTdsh0w_oMXY6trPg3FWm1pN1OfGfnbNAWsu3ODkyI3pfHFDfZAPJ2NHhixT7UKxeYYB-9YOmJIutiywx1CUZHdABaNv733Y1R0q-9Sx-tywHjFus5PcUgLqH4LMLMQvzduLxpVV44eJh29AKzLYBACsnUCFygxfh1zti5u7VdnKhmBMf8t6_tfSVzaUIaf0uBLeyQwJH56K7nyzHzY0wsIr3zZ8f7PXJt4vvJ74dbW05rDwVjBkXoT4EpwsCH6udlt1_nTQVER-hr8IPxs1KFHl4IG63SamYKzFROo48MMCcQT17paPgSa-P-gDeI6Amr3CvZP5_0SA'
            }
        }
        await axios.get(`https://map.ir/reverse/no?lat=${e.lngLat.lat}&lon=${e.lngLat.lng}`, configs)
            .then((response: any) => {
                setAdress(response.data.address)
                setLongitude(response.data.geom.coordinates[0])
                setLatitude(response.data.geom.coordinates[1])
            })
        if (markerRef.current) {
            markerRef.current.style.left = `${e.point.x}px`;
            markerRef.current.style.top = `${e.point.y}px`;
        }
    }
    return { plans, order_id, isLoading, register, handleSubmit, coord, pending, onSubmit, reverseFunction, value, setValue, markerRef, address }
}